const MasterCardLogo = () => (
  <svg fill="none" height="24" viewBox="0 0 36 24" width="36" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 6.40024C0 4.16003 0 3.03993 0.435974 2.18428C0.819467 1.43163 1.43139 0.819712 2.18404 0.436218C3.03968 0.000244141 4.15979 0.000244141 6.4 0.000244141H29.6C31.8402 0.000244141 32.9603 0.000244141 33.816 0.436218C34.5686 0.819712 35.1805 1.43163 35.564 2.18428C36 3.03993 36 4.16003 36 6.40024V17.6002C36 19.8405 36 20.9606 35.564 21.8162C35.1805 22.5689 34.5686 23.1808 33.816 23.5643C32.9603 24.0002 31.8402 24.0002 29.6 24.0002H6.4C4.15979 24.0002 3.03968 24.0002 2.18404 23.5643C1.43139 23.1808 0.819467 22.5689 0.435974 21.8162C0 20.9606 0 19.8405 0 17.6002V6.40024Z"
      fill="white"
    />
    <path
      d="M13 19.0002C16.866 19.0002 20 15.8662 20 12.0002C20 8.13425 16.866 5.00024 13 5.00024C9.13401 5.00024 6 8.13425 6 12.0002C6 15.8662 9.13401 19.0002 13 19.0002Z"
      fill="#EB001B"
    />
    <path
      d="M23 19.0002C26.866 19.0002 30 15.8662 30 12.0002C30 8.13425 26.866 5.00024 23 5.00024C19.134 5.00024 16 8.13425 16 12.0002C16 15.8662 19.134 19.0002 23 19.0002Z"
      fill="#F79E1B"
    />
    <path
      clipRule="evenodd"
      d="M18 7.10132C16.7628 8.36386 16 10.093 16 12.0003C16 13.9076 16.7628 15.6367 18 16.8993C19.2372 15.6367 20 13.9076 20 12.0003C20 10.093 19.2372 8.36386 18 7.10132Z"
      fill="#FF5F00"
      fillRule="evenodd"
    />
    <rect height="23.5" rx="3.75" stroke="black" strokeWidth="0.5" width="35.5" x="0.25" y="0.250244" />
  </svg>
)

export default MasterCardLogo
